import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DocumentUploadConfigs from './components/DocumentUploadConfigs';

const smartScreenBuilderConfigs = ({ t }) => (
  <Container>
    <DocumentUploadConfigs />
  </Container>
);

smartScreenBuilderConfigs.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(smartScreenBuilderConfigs);